module.exports = __webpack_public_path__ + "static/media/kontakt_headerimage.6ddcaad8.jpg";


//////////////////
// WEBPACK FOOTER
// /src/images/kontakt_headerimage.jpg
// module id = 1604
// module chunks = 0